import { generateRoute } from "../routing/resolveRoute";
import type { ApiResourceRoute } from "./types";
import { createQueriedResourceRoute } from "./resourceRoute";

export function withApiQuery<TEntity>(
  resourceRoute: ApiResourceRoute<TEntity>,
  query: Readonly<Record<string, string | number | boolean>>,
): ApiResourceRoute<TEntity> {
  const params = new URLSearchParams(
    Object.entries(query).map(([key, value]) => [key, String(value)]),
  );
  const separator = resourceRoute.route.includes("?") ? "&" : "?";
  return createQueriedResourceRoute(
    resourceRoute,
    `${resourceRoute.route}${separator}${params}`,
  );
}

export function resolveApiResourceUrl(resourceRoute: ApiResourceRoute) {
  return generateRoute(
    resourceRoute.route,
    resourceRoute.descriptor.clientType,
  );
}

export function isApiResourceRoute(value: unknown): value is ApiResourceRoute {
  return (
    value != null &&
    typeof value === "object" &&
    "route" in value &&
    typeof value.route === "string" &&
    "descriptor" in value
  );
}
